import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { matchPath, useLocation } from 'react-router-dom'

import {
  COMMON_MIXPANEL_PROPERTIES,
  COMMON_SEARCH_FOR_CARE_SCREENS,
} from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import { PAGE_ROUTES } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/routingConstants'

import { getUserChildren } from '../../data/user/userSelectors'
import { routeToPageMap } from '../constants/mixpanelConstants'

export const useDefaultMixpanelPage = () => {
  const location = useLocation()
  const userChildren = useSelector(getUserChildren)
  const userChildrenLength = useMemo(() => {
    return userChildren?.size ?? 0
  }, [userChildren])

  return useMemo(() => {
    const currentRoute = location.pathname
    let page = routeToPageMap[currentRoute]
    if (currentRoute === PAGE_ROUTES.ONBOARD.ABOUT_CHILD) {
      page =
        userChildrenLength > 0
          ? COMMON_SEARCH_FOR_CARE_SCREENS.CHILD_SELECTION
          : COMMON_SEARCH_FOR_CARE_SCREENS.CHILD_INFORMATION
    }
    // If no exact match, try pattern matching for dynamic routes
    if (!page) {
      for (const [routePattern, pageValue] of Object.entries(routeToPageMap)) {
        if (routePattern.includes(':')) {
          const match = matchPath({ path: routePattern }, currentRoute)
          if (match) {
            page = pageValue
            break
          }
        }
      }
    }
    if (page) {
      return { [COMMON_MIXPANEL_PROPERTIES.PAGE]: page }
    }
    return {}
  }, [location.pathname, userChildrenLength])
}
